module.exports = "fragment ParagraphFragment on Paragraph {\n  __typename\n  textFragments {\n    ...TextFragmentFragment\n  }\n  alignment\n}\n"